// extracted by mini-css-extract-plugin
export default {"container":"ReasonCard_container__SWpm0","icon":"ReasonCard_icon__8mQ-Y","heading":"ReasonCard_heading__-ha8d","detail":"ReasonCard_detail__8EhQT"};